import { render, staticRenderFns } from "./ContactsFooter.vue?vue&type=template&id=145c2eec&scoped=true&"
import script from "./ContactsFooter.vue?vue&type=script&lang=js&"
export * from "./ContactsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c2eec",
  null
  
)

export default component.exports